import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { changePassword } from "../../store/slices/userSlice";
import AccountLayout from "../../blocs/AccountLayout";
import PasswordInput from "../../components/inputs/PasswordInput";
import { toast } from "react-toastify";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, loading, error } = useSelector(
    (state) => state.user
  );
  const [successMessage, setSuccessMessage] = React.useState("");

  const initialValues = {
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  };

  const validationSchema = Yup.object().shape({
    current_password: Yup.string().required(
      "Le mot de passe actuel est requis."
    ),
    new_password: Yup.string()
      .min(8, "Le mot de passe doit contenir au moins 8 caractères.")
      .notOneOf(
        [Yup.ref("current_password")],
        "Le nouveau mot de passe doit être différent de l'ancien."
      )
      .required("Le nouveau mot de passe est requis."),
    new_password_confirmation: Yup.string()
      .oneOf(
        [Yup.ref("new_password"), null],
        "Les nouveaux mots de passe ne correspondent pas."
      )
      .required("La confirmation du mot de passe est requise."),
  });

  const handleSubmit = (values, { resetForm }) => {
    // if(values?.current_password===values?.new_password){
    //   toast.warning('')
    // }
    if (!isAuthenticated) {
      dispatch({
        type: "user/changePassword/rejected",
        payload: "Vous devez être connecté pour changer votre mot de passe.",
      });
      return;
    }

    dispatch(changePassword(values))
      .unwrap()
      .then(() => {
        toast.success("Mot de passe mis à jour avec succès");
        resetForm();
        setTimeout(() => setSuccessMessage(""), 3000);
      })
      .catch((err) => {
        // console.error("Password change failed:", err);
      });
  };

  if (!isAuthenticated) {
    return <div>Veuillez vous connecter pour accéder à cette page.</div>;
  }

  return (
    <AccountLayout bgColor={"bgColor"}>
      <HelmetProvider>
        <Helmet>
          <title>Changement mot de passe </title>
          <meta name="description" content=" Page changement mot de passe " />
        </Helmet>
      </HelmetProvider>
      <div className="change-password-page">
        <h3 className="pd-bt-24">Changer de mot de passe</h3>
        <p className="body">
          Pour modifier votre mot de passe, veuillez saisir votre mot de passe
          actuel afin de vérifier votre identité.
        </p>

        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && (
          <div className="alert alert-success">
            <img src="/images/check-circle.svg" alt="Success" />
            {successMessage}
          </div>
        )}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange }) => (
            <Form className="change-password-form col-md-8">
              <div className="form-group">
                <label htmlFor="current_password" className="legend">
                  Mot de passe actuel*
                </label>
                <PasswordInput
                  id="current_password"
                  name="current_password"
                  value={values.current_password}
                  onChange={handleChange}
                  required
                  className="form-control mt-4"
                />
                <ErrorMessage
                  name="current_password"
                  component="div"
                  className="text-danger"
                />
              </div>

              <div className="form-group">
                <label htmlFor="new_password" className="legend">
                  Mot de passe*
                </label>
                <PasswordInput
                  id="new_password"
                  name="new_password"
                  value={values.new_password}
                  onChange={handleChange}
                  required
                  className="form-control mt-4"
                />
                <span className="legend">
                  Le mot de passe doit faire plus de 8 caractères
                </span>
                <ErrorMessage
                  name="new_password"
                  component="div"
                  className="text-danger"
                />
              </div>

              <div className="form-group pd-bt-28">
                <label htmlFor="new_password_confirmation" className="legend">
                  Confirmer le nouveau mot de passe*
                </label>
                <PasswordInput
                  id="new_password_confirmation"
                  name="new_password_confirmation"
                  value={values.new_password_confirmation}
                  onChange={handleChange}
                  required
                  className="form-control mt-4"
                />
                <ErrorMessage
                  name="new_password_confirmation"
                  component="div"
                  className="text-danger"
                />
              </div>

              <button
                type="submit"
                className="twyny-cta-primary"
                disabled={loading}
              >
                {loading ? "Enregistrement..." : "Changer mon mot de passe"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </AccountLayout>
  );
};

export default ChangePassword;
